var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58611 10.5754C8.79446 11.1738 7.81582 11.5291 6.74992 11.5291C4.15059 11.5291 2.03125 9.40978 2.03125 6.81046C2.03125 4.21738 4.15059 2.0918 6.74992 2.0918C9.34923 2.0918 11.4686 4.21738 11.4686 6.81046C11.4686 7.92624 11.0821 8.94851 10.4276 9.75885L13.588 12.9192C13.7002 13.0314 13.75 13.181 13.75 13.3306C13.75 13.6547 13.5194 13.9228 13.1703 13.9228C13.0145 13.9228 12.8649 13.8604 12.7589 13.7544L9.58611 10.5754ZM2.82288 6.81046C2.82288 8.96721 4.59316 10.7375 6.74992 10.7375C8.90666 10.7375 10.6769 8.96721 10.6769 6.81046C10.6769 4.65995 8.90666 2.88344 6.74992 2.88344C4.59316 2.88344 2.82288 4.65995 2.82288 6.81046Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.2a4148be9f45f5efc3523dfada52598b.svg";
export { ForwardRef as ReactComponent };